
import ParceiroByid from './parceiro'
import Parceiros from './parceiros'
import SalvarParceiro from './salvarParceiro'
import DeletarParceiro from './deletarParceiro'
import TokenParceiro from './tokenParceiro'

export default {
    Parceiros,     
    SalvarParceiro, 
    ParceiroByid,   
    DeletarParceiro, 
    TokenParceiro, 
}